module.exports = __webpack_public_path__ + "img/shield-user-line-trans.5880aae8.svg";